import React from "react";
import Layout from "./src/components/layouts/layout";

export const wrapPageElement = ({ element }) => {
  return <Layout>{element}</Layout>;
};
